import { Component, OnChanges, SimpleChanges, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { TrackHealthCenterExternalLinkClickAction } from 'src/app/actions/tracking';

import { IHealthCenterProtocolsResponse, TravelDocument } from '../../../models/governance-content.payload';
import { HealthCenterSailingInfo } from '../../../models/session';
import * as fromRoot from '../../../reducers';

const OLCI_IMAGE_URL_PREFIX = 'assets/images/';

@Component({
    selector: 'app-health-center-page',
    templateUrl: './health-center-page.component.html',
    styleUrls: ['./health-center-page.component.scss'],
    standalone: false
})
export class HealthCenterPageComponent implements OnChanges {
	readonly bundle = input<any>();
	readonly healthCenterResp = input<IHealthCenterProtocolsResponse | any>();
	readonly sailing = input<HealthCenterSailingInfo | any>();
	readonly brandName = input<string | any>();
	readonly urlPrefix = input<string | any>();

	protocols: TravelDocument[] = [];
	olciUrlprefix: string = OLCI_IMAGE_URL_PREFIX;

	constructor(private store: Store<fromRoot.AppState>) {}

	ngOnChanges(changes: SimpleChanges) {
		if (
			changes['healthCenterResp']?.currentValue?.payload?.protocols?.length
		) {
			this.protocols = changes['healthCenterResp'].currentValue.payload.protocols;
		}
	}

	onClickExternalLink(linkText:string): void {
		this.store.dispatch(new TrackHealthCenterExternalLinkClickAction({linkText}));
	}
}
